import React from 'react';

import Select from 'react-select';
import 'react-select/dist/react-select.css';

export default class MarriedStatus extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selected: 1,
            options: [
                {
                    value: 1,
                    label: 'Single',
                },
                // {
                //     value: 2,
                //     label: 'Single with Children',
                // },
                // {
                //     value: 3,
                //     label: 'Divorced or Widowed',
                // },
                {
                    value: 4,
                    label: 'Married and spouse is working',
                },
                {
                    value: 5,
                    label: 'Married and spouse is NOT working',
                },
                // {
                //     value: 6,
                //     label: 'Married and spouse is disabled',
                // }
            ]
        };
    }

    handleChange = ({ value }) => {
        if (this.props.handleChange) {
            this.props.handleChange(value);
        }

        this.setState(Object.assign({},
            this.state,
            {
                selected: value
            }
        ));
    }

    render() {
        const { selected } = this.state;

        return (
            <div className='married-status pcb-select'>
                <label>
                    Married Status
                </label>

                <Select
                    name="form-field-name"
                    value={selected}
                    onChange={this.handleChange}
                    options={this.state.options}
                    searchable={false}
                    clearable={false}
                    alwaysOpened={true}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Calculator/MarriedStatus.js